import * as React from 'react';
import { LoadingPage } from '../../pages/components/loading/index.';
import { useLocation, Navigate, useSearchParams} from 'react-router-dom';
import { useAuth } from '../../context/AuthContext.component';

export function RequireAuthQuote({ children }: { children: JSX.Element }) {
  let auth = useAuth();
  let location = useLocation();

  if (auth?.user?.quote_id === undefined) {
    return <Navigate to={"/quote/signin"}/>;
  }

  return children;
}

export function RequireAuthCustomer({ children }: { children: JSX.Element }) {
  let auth = useAuth();
  let location = useLocation();

  if (auth?.user?.job_number === undefined) {
    return <Navigate to={"/customer/signin"} />;
  }

  return children;
}